module.exports = __webpack_public_path__ + "img/step4-fr.ee22e299.webp";